import template from './userSummarySection.html';

export const userSummarySectionComponent = {
  name: 'userSummarySectionComponent',
  restrict: 'E',
  template,
  transclude: true,
  controllerAs: 'vm',
  bindings: {
    className: '@',
    icon: '@',
    title: '@',
    body: '@'
  }
};
